// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!/Users/kirill/projects/hexlet-ide/node_modules/css-loader/index.js!/Users/kirill/projects/hexlet-ide/node_modules/codemirror/lib/codemirror.css");
if(typeof content === 'string') content = [module.id, content, ''];
// add the styles to the DOM
var update = require("!/Users/kirill/projects/hexlet-ide/node_modules/style-loader/addStyles.js")(content);
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	module.hot.accept("!!/Users/kirill/projects/hexlet-ide/node_modules/css-loader/index.js!/Users/kirill/projects/hexlet-ide/node_modules/codemirror/lib/codemirror.css", function() {
		var newContent = require("!!/Users/kirill/projects/hexlet-ide/node_modules/css-loader/index.js!/Users/kirill/projects/hexlet-ide/node_modules/codemirror/lib/codemirror.css");
		if(typeof newContent === 'string') newContent = [module.id, newContent, ''];
		update(newContent);
	});
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/codemirror/lib/codemirror.css
 ** module id = 17
 ** module chunks = 0
 **/